import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { identifyComponent } from '../../util';
import { ButtonBase } from '../ButtonBase';
import { Text, TextAppearance } from '../Text';
import css from './index.module.scss';

type TagSizeOptions = 'sm' | 'md';

export const sizeToAppearanceMap: Record<TagSizeOptions, TextAppearance> = {
  sm: 'bodySmallBold',
  md: 'bodyMediumBold',
};

export interface TagProps extends React.ComponentPropsWithoutRef<typeof ButtonBase> {
  /** When `true`, the tag will be styled as though it is selected or enabled */
  active?: boolean;
  disabled?: boolean;
  size?: TagSizeOptions;
}

export const Tag: React.FC<TagProps> = ({
  active = false,
  disabled = false,
  size = 'sm',
  children,
  ...rest
}) => (
  <ButtonBase
    data-component="Tag"
    className={classNames(css.tag, css[size], { [css.active]: active })}
    testId="tag"
    {...rest}
    {...identifyComponent('tag', rest)}
  >
    <Text
      appearance={sizeToAppearanceMap[size]}
      color={disabled ? 'disabled' : active ? 'default-inverse' : 'default'}
      tag="div"
    >
      {children}
    </Text>
  </ButtonBase>
);
